import { Box } from '@mui/material';

import { TipoPagamento } from '../../../../models/TipoPagamento';
import { isPagamentoYuno } from '../../../../shared/functions/tipoPagamento';
import { PagamentoAdyen } from '../PagamentoAdyen/PagamentoAdyen';
import { PagamentoYuno } from '../PagamentoYuno/PagamentoYuno';

interface Props {
  pagamentoId?: string;
  pagamentoValor?: number;
  tipoPagamento: TipoPagamento.Pix | TipoPagamento.YunoPix;
  onPaymentFailed: (reason?: string) => void;
  onPaymentCompleted: () => void;
}

const PagamentoPorPix = ({
  pagamentoId = '',
  pagamentoValor,
  tipoPagamento,
  onPaymentFailed,
  onPaymentCompleted
}: Props) => {
  const usarYuno = isPagamentoYuno(tipoPagamento);

  return (
    <Box display="flex" flex={1} padding={2}>
      {usarYuno ? (
        <PagamentoYuno
          pagamentoId={pagamentoId}
          pagamentoValor={pagamentoValor}
          type="pix"
          onPaymentFailed={onPaymentFailed}
          onPaymentCompleted={onPaymentCompleted}
        />
      ) : (
        <PagamentoAdyen
          pagamentoId={pagamentoId}
          type="pix"
          onPaymentFailed={onPaymentFailed}
          onPaymentCompleted={onPaymentCompleted}
        />
      )}
    </Box>
  );
};

export default PagamentoPorPix;
